module.exports = __webpack_public_path__ + "static/img/DANIEL-CURTIN.70d93ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DANIEL-CURTIN.jpg
// module id = yWed
// module chunks = 0